import { ChartOptions, TimeUnit } from 'chart.js';

interface Config {
    intervalUnit?: TimeUnit;
    grace?: string | null;
}

export const getGenericSparkChartOptions: (config: Config) => ChartOptions<'line'> = ({
    intervalUnit,
    grace = '10%',
}: Config) => {
    return {
        interaction: {
            mode: 'nearest',
            axis: 'xy',
            intersect: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        events: [],
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        scales: {
            y: {
                grace,
                display: false,
            },
            x: {
                grace,
                display: false,
                type: 'time',
                time: {
                    unit: intervalUnit,
                },
            },
        },
    };
};
